import {http} from '../utils'

const getReportTagList = params => {
  const url = `/api/v1/report/tag/page`
  return http.post(url, params)
}

const saveReportTag = params => {
  const url = `/api/v1/report/tag/save`
  return http.post(url, params)
}

const deleteReportTag = id => {
  const url = `/api/v1/report/tag/delete/${id}`
  return http.post(url)
}

export default {
  getReportTagList,
  saveReportTag,
  deleteReportTag
}